/**
 * Asynchronously loads the Dialog
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "dialog" */ './Dialog'),
  loading: () => null,
});
